import React from "react";
import Link from "next/link";

import useTemplateInfoModal from "@hooks/use-template-info-modal";

import ShimmerWrapper from "@stadium/ui/src/components/loaders/shimmer-wrapper";

import ShadowCard from "@sharedComponents/cards/shadow";
import StorePreviewImage from "@sharedComponents/store-preview-image";
import UseTemplateCTA from "@sharedComponents/content-links/use-template-cta";

import { stopEventPropagation } from "@stadium/helpers/resource";

import { TEMPLATES } from "@constants/routes";

import styles from "./purge-main.module.scss";
import { DEFAULT_ACCOUNT_SHOP_LONG_DES } from "@constants/templates-listing/info-pop-up";

const emptyObj = {};

const RecommendedTemplate = (shop) => {
  const {
    loadingAccountShops,
    topBannerImage = "",
    sampleProductsImage = "",
    storeName = "",
    storeNumber = "",
    recommendedAccount = emptyObj,
    onTemplateSelect = () => {},
    pageName = "",
  } = shop;
  const { name: recommendAccountName = "", slug: recommendAccountSlug = "" } = recommendedAccount;

  const modifiedShop = {
    ...shop,
    shortDescription: shop?.storeDetail?.shortDescription,
    longDescription: shop?.storeDetail.longDescription || DEFAULT_ACCOUNT_SHOP_LONG_DES,
  };

  const [openTemplateInfoModal, renderTemplateInfoModal] = useTemplateInfoModal(modifiedShop);

  if (loadingAccountShops)
    return (
      <ShimmerWrapper length={3} cardClass={styles.shadowCardCol} wrapperClass={styles.shopRow}>
        <ShadowCard customClass="chooseTemplate" />
      </ShimmerWrapper>
    );

  return (
    <>
      <div className={styles.templatesContentSection}>
        <div className={`${styles.templateBlockHolder} ${styles.recommendTemplate}`}>
          <div className={styles.templateTileHolder} onClick={openTemplateInfoModal}>
            <div className={styles.templateImageContainer}>
              <StorePreviewImage
                topBanner={topBannerImage}
                productsThumbImage={sampleProductsImage}
                width={554}
                height={440}
                className={styles.templateBanner}
                topBannerClassName={styles.templateBannerTopImage}
                bottomBannerClassName={styles.templateBannerBottomImage}
              />
            </div>

            <div className={styles.templateTileContentBlock}>
              <div className={styles.templateTileContentTitle} tabIndex={0}>{storeName}</div>
              <div className={styles.templateTileContentLinkRow}>
                <UseTemplateCTA
                  className={styles.templateTileContentLink}
                  pageName={pageName}
                  storeName={storeName}
                  storeNumber={storeNumber}
                  onTemplateSelect={onTemplateSelect}
                />
                <Link
                  href={`${TEMPLATES}/${recommendAccountSlug}`}
                  className={styles.templateTileContentLink}
                  onClick={stopEventPropagation}
                  title="View All {recommendAccountName} Templates"
                >
                  View All {recommendAccountName} Templates
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderTemplateInfoModal}
    </>
  );
};

export default RecommendedTemplate;
